module.exports = __webpack_public_path__ + "img/congress1.a708dda9.jpg";